<template>
    <span>
        {{ formattedDate }}
    </span>
</template>

<script setup>
    const props = defineProps({
        date: String,
        end: String,
        displaySameDay: {
            type: Boolean,
            default: true
        },
        format: {
            type: String,
            default: 'lll'
        },
        locale: {
            type: String,
            default: 'en-au'
        },
        fromNow: {
            type: Boolean,
            default: false
        },
    })

    const dayjs = useDayjs()

    dayjs.locale(props.locale)

    const formattedDate = computed(() => {
        const startDate = dayjs(props.date)
        let endDate = null

        if (props.fromNow) {
            return startDate.fromNow()
        }

        if (props.end) {
            endDate = dayjs(props.end)
        }

        if (endDate && endDate.isValid()) {
            if (startDate.isSame(endDate, 'day') && props.displaySameDay) {
                return `${startDate.format(props.format)} - ${endDate.format('LT')}`
            }

            if (startDate.isSame(endDate, 'day') && !props.displaySameDay) {
                return `${startDate.format(props.format)}`
            }

            return `${dayjs(props.date).format(props.format)} - ${dayjs(props.end).format(props.format)}`
        }
        return startDate.format(props.format)
    })

</script>

<style lang="scss" scoped>

</style>